import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { InternalGa4Actions } from '../actions'

export function* disconnect() {
  const projectId: string | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === null) {
    return
  }

  try {
    yield call(API.GoogleAnalytics.disconnect, projectId)

    yield put(InternalGa4Actions.reset())
    yield put(InternalGa4Actions.reportLoaded({ status: 'not_connected' }))
  } catch {
    yield put(InternalGa4Actions.reportFailed('error'))
  }
}
